import { useContext } from "react"
import { UserContext } from "../../store/store"

const Breadcrumb = ({ entries }) => {
  const [state] = useContext(UserContext)
  const last = entries.slice(-1)

  return (
    <>
      <div className="d-flex flex-row justify-content-center">
        <div
          className={"sound-alert " + state.theme}
          style={{ width: "fit-content" }}>
          {entries.slice(0, -1).map((entry, eix) => (
            <span key={eix}>{entry} &gt;&nbsp;</span>
          ))}
          {last && <span>{last}</span>}
        </div>
      </div>
    </>
  )
}

export { Breadcrumb }
